import { render } from "./New_UserForm.vue?vue&type=template&id=76f80ffc&scoped=true"
import script from "./New_UserForm.vue?vue&type=script&lang=js"
export * from "./New_UserForm.vue?vue&type=script&lang=js"

import "./New_UserForm.vue?vue&type=style&index=0&id=76f80ffc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f80ffc"]])

export default __exports__